import Error404 from "@/views/error404/error404.vue";

export default [
  {
    path: "",
    name: "root",
    redirect: () => {
      return { path: "/mi-menu" };
    },
  },
  {
    path: "/error",
    component: Error404,
    name: "error-404",
  },
];
